import * as z from "zod";
import {ManagerSummaryModel} from "./ManagerSummaryModel";
import {ManagerVisitHistoryModel} from "./ManagerVisitHistoryModel";

const schema = z.object({
	managerVisitHistories: z.array(ManagerVisitHistoryModel.model),
	managerSummaryResponses: z.array(ManagerSummaryModel.model)
});

const model = schema.transform((values) => ({
	...values
}));

export const ReportOneResModel = {schema, model};
export type IReportOneResModel = z.infer<typeof ReportOneResModel.model>;
export const DEFAULT_REPORT_ONE_RES: IReportOneResModel = {
	managerVisitHistories: [],
	managerSummaryResponses: []
};
